export default __webpack_public_path__ + "static/media/logo3.25d0de1c.webp";